import React from 'react'
import { withTheme } from 'styled-components'
import { Card } from 'adl'

export default withTheme(({ theme, children, ...rest }) => (
  <Card {...rest}>
    <Card.Body>
      <img
        src={theme.branding.logo}
        height={56}
        style={{ marginBottom: '2rem', objectFit: 'cover' }}
        alt="brand logo"
      />
      {children}
    </Card.Body>
  </Card>
))
